// Agent Options (System Settings)
export const AGENT_OPTIONS_INDEX = 250;
export const AGENT_OPTIONS_UPDATE_COMPANY_INFO = 251;
export const AGENT_OPTIONS_UPDATE_GOVERNMENT_LICENSES = 252;
export const AGENT_OPTIONS_UPDATE_COMMUNICATION_CHANNELS = 253;
export const AGENT_OPTIONS_UPDATE_ZACTA_CONFIG = 254;
export const AGENT_OPTIONS_UPDATE_BILLING_INFO = 255;
export const AGENT_OPTIONS_UPDATE_DOCUMENTS_PREFIXES = 256;
export const AGENT_OPTIONS_UPDATE_AGENT_OWNED_MARKETPLACE = 257;
export const AGENT_OPTIONS_UPDATE_ONLINE_PAYMENT_GATEWAY_INTEGRATION = 258;
export const AGENT_OPTIONS_UPDATE_CONTRACT_SERIAL_PREFIXES = 1310;

/** agent-options.get-zacta-status — View ZATCA integration status */
export const AGENT_OPTIONS_GET_ZACTA_STATUS = 316;

/** agent-options.revoke-zacta-config — Revoke ZATCA integration configuration */
export const AGENT_OPTIONS_REVOKE_ZACTA_CONFIG = 317;

/** agent-options.get-ejar-credentials — View stored Ejar (EJR) API credentials */
export const AGENT_OPTIONS_GET_EJAR_CREDENTIALS = 1341;

/** agent-options.update-ejar-credentials — Save/update Ejar (EJR) API credentials */
export const AGENT_OPTIONS_UPDATE_EJAR_CREDENTIALS = 1342;

/**
 * agent-options.update-crm — the CRM settings section.
 *
 * Gates reading as well as writing: the payload carries the web-to-lead API key,
 * which is a credential rather than a preference.
 */
export const AGENT_OPTIONS_UPDATE_CRM = 1452;

/**
 * agent-options.get-ads-cross-listing — read the Ads Cross Listing section.
 *
 * Its own key rather than AGENT_OPTIONS_INDEX, the Ejar-credentials precedent:
 * the payload describes a credential (the portal's client id, and whether a
 * secret is stored), not a preference.
 */
export const AGENT_OPTIONS_GET_ADS_CROSS_LISTING = 1583;

/** agent-options.update-ads-cross-listing — enable a listing app and save its credentials */
export const AGENT_OPTIONS_UPDATE_ADS_CROSS_LISTING = 1584;

/**
 * agent-options.get-sadq-settings — read the Sadq (e-signature) section.
 *
 * Its own key rather than AGENT_OPTIONS_INDEX, the Ejar-credentials and Ads
 * Cross Listing precedent: the payload describes credentials (the account id,
 * the integration username, and whether a secret and a password are stored),
 * not a preference.
 *
 * The id is the central key service's approval number, which
 * `PermissionService::createAndGrantToOwners()` writes as the permission row's
 * id — it must stay equal to what
 * `database/migrations/2026_09_13_000020_add_esign_permissions.php` produces,
 * or the section renders for nobody. Issued 13 September 2026 alongside the
 * eleven `esign.*` keys in `permissions/esign.js`.
 */
export const AGENT_OPTIONS_GET_SADQ_SETTINGS = 1598;

/** agent-options.update-sadq-settings — enable Sadq, save its credentials, register its webhook */
export const AGENT_OPTIONS_UPDATE_SADQ_SETTINGS = 1599;

/**
 * agent-options.get-sms-provider — read Settings → SMS providers (the office's
 * own Msegat account), its balance, and the Sender ID authorization letter.
 */
export const AGENT_OPTIONS_GET_SMS_PROVIDER = 1674;

/** agent-options.update-sms-provider — connect, edit or disconnect the account, and request one from the Amer team */
export const AGENT_OPTIONS_UPDATE_SMS_PROVIDER = 1675;

/** agent-options.get-private-domain — read Settings → Private domain, its DNS records, and check its status now */
export const AGENT_OPTIONS_GET_PRIVATE_DOMAIN = 1676;

/** agent-options.update-private-domain — register, connect or move a domain, edit its DNS records and renewal settings, and disconnect it */
export const AGENT_OPTIONS_UPDATE_PRIVATE_DOMAIN = 1677;

/** agent-options.get-whatsapp-provider — read Settings → WhatsApp, its templates, and check its status now */
export const AGENT_OPTIONS_GET_WHATSAPP_PROVIDER = 1682;

/** agent-options.update-whatsapp-provider — connect the number, switch sending, resubmit templates and disconnect */
export const AGENT_OPTIONS_UPDATE_WHATSAPP_PROVIDER = 1683;
